// This keeps track of when the dialogue on the landing page should first be shown.
// If we decide to differentiate between "Resume" and "Play" buttons in the menu,
// this can also help differentiate when the intro scene should be played.
export const GAME_FIRST_INITIALIZED_KEY = 'game_first_initialized';

export enum GameState {
    MAIN_MENU,
    CREDITS,
    INTRO_SCENE,
    GAME_LANDING_PAGE,
    EPILOGUE,
    // Minigames should be listed below.
    HOT_DOG_GAME,
    PHONE_GAME,
    LAUNDRY_GAME,
}

export const defaultMinigameProgress = {
    [GameState.HOT_DOG_GAME]: false,
    [GameState.PHONE_GAME]: false,
    [GameState.LAUNDRY_GAME]: false,
};

// These messages are shown if the player tries to click into a game that they
// previously finished already.
export const MINIGAME_DONE_MESSAGES = {
    [GameState.HOT_DOG_GAME]: [
        "There are too many buns and not enough sausages. But if I buy more sausages,\nthere'll be too many sausages and not enough buns... this is so tragic.",
    ],
    [GameState.PHONE_GAME]: [
        'Messages messages messages... why do people keep asking for things?',
    ],
    [GameState.LAUNDRY_GAME]: ["I'll never find my missing sock...."],
};
